import React, { useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { VegaFlex, VegaCard, VegaIcon, VegaFont, VegaCounterBadge, VegaBox } from "@heartlandone/vega-react";
import {
  NavLink,
} from "react-router-dom";
import Forms from 'Forms/Form';
import ContentView from './ContentView';
import { HubContext } from 'Redux/Context/context';
import { PATH } from 'Chore/Apis';
import { pendFeedbackCountAction } from 'Redux/Actions/actions';
import { _fetch } from "Chore/Request";

function Root() {
  const { formState } = useContext(HubContext);
  const [currentTab, setCurrentTab] = useState('GP Activity');
  const location = useLocation();
  const { GET_ACTIVITIES } = PATH;
  const { pendFeedbackCountDispatch, reloadActivitiesState } = useContext(HubContext);
  const [pendingTotal, setPendingTotal] = useState();
  
  useEffect(() => {
    _fetch({
      api: `${GET_ACTIVITIES}`,
      params : {
        PageIndex: 1,
        PageSize: 2,
        Period: 'Last3Month',
        FeeType: 'All',
        PublisherCategory: 0,
        IsFeedback:'PendingFeedback',
        Category: 'Registered'
      }
    }).then((res) => {
      if(res.code === 2200){
        setPendingTotal(res?.payload?.totalCount);
        pendFeedbackCountDispatch(
          pendFeedbackCountAction(res?.payload?.totalCount || 0)
        );
      }
    })
  }, [GET_ACTIVITIES, pendFeedbackCountDispatch, reloadActivitiesState]);

  useEffect(() => {
    setCurrentTab(location.pathname.startsWith('/my-activity') ? 'My Activity' : 'GP Activity');
  }, [location.pathname]);
  
  return (
    <div className='relative' style={{ minHeight: 'calc(100vh - 252px)' }}>
      <VegaFlex gap={'size-16'} >
        <div>
          <VegaCard
            padding="size-12" style={{ width: 260 }} className={'round-12'}>
            <h6 className='f-size-12 f-weight-400 line-height-16 font-normal p-8-12 m-0'>TEAM GP</h6>
            <NavLink
              to={`/`}
              style={{textDecoration: 'none'}}
              className={() => 'side-menu'}
            >
              <div className={`f-size-16 f-weight-500 line-height-24 font-normal p-8-12 round-12 pointer ${(currentTab === 'GP Activity') && 'bg-light-Background-Background-selected'}`}>
                <VegaIcon
                  icon="fas fa-chart-network"
                  size="size-16"
                  color='text-primary'
                />
                <VegaFont className="m-l-12" variant='text-primary'>CDS Activities</VegaFont>
              </div>
            </NavLink>
            <NavLink
              to={`/my-activity`}
              style={{textDecoration: 'none'}}
              className={() => 'side-menu'}
            >
              <div className={`f-size-16 f-weight-500 line-height-24 font-normal p-8-12 round-12 pointer ${(currentTab === 'My Activity') && 'bg-light-Background-Background-selected'}`}>
                <VegaFlex justifyContent={'space-between'}>
                  <VegaFlex alignItems={'center'}>
                    <VegaIcon
                      icon="fa-solid fa-inbox-full"
                      size="size-16"
                      color='text-primary'
                      style={{
                        padding: '0 2px 0 2px'
                      }}
                    />
                    <VegaFont className="m-l-12" variant='text-primary'>My Activities</VegaFont>
                  </VegaFlex>
                  <VegaCounterBadge
                    count={pendingTotal}
                    color='bg-action'
                    offset={[-12, 12 ]} 
                  >
                    <VegaBox></VegaBox>
                  </VegaCounterBadge>
                </VegaFlex>
              </div>
            </NavLink>
          </VegaCard>
        </div>
        <ContentView />
      </VegaFlex>
      <Forms name={formState.name} activity={formState.activity} isEdit={formState.isEdit} />
    </div>
  );
}

export default Root;
